function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo, useEffect, useRef, useState, useCallback } from 'react';
import JoditEditor from 'jodit-react';
import { Jodit } from 'jodit';
import { Box } from 'grommet';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const StyledBox = styled(Box)`
  .ace_editor * {
    font-size: 16px !important;
  }
  .jodit-add-new-line.jodit-add-new-line_after {
    display: none;
  }
`;
const RichTextEditor = ({
  initialValue,
  onBlur,
  onChange,
  className,
  containerProps,
  minHeight,
  maxHeight,
  autofocus,
  readonly,
  placeholder,
  buttons,
  styles,
  setJoditInstance
}) => {
  const editor = useRef(null);
  const [value, setValue] = useState(initialValue || '');
  useEffect(() => {
    let joditInstance = null;
    Jodit.plugins.add('mentions', function (jodit) {
      setJoditInstance(jodit);
    });
    return () => {
      if (joditInstance) joditInstance.destruct();
    };
  }, [setJoditInstance]);
  const handleChange = useCallback(data => {
    setValue(data);
    onChange(data);
  }, [onChange]);
  const configs = useMemo(() => {
    return {
      uploader: {
        insertImageAsBase64URI: true
      },
      enter: 'DIV',
      spellcheck: true,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      editHTMLDocumentMode: true,
      showTooltipDelay: 0,
      minHeight: minHeight,
      maxHeight: maxHeight,
      autofocus: autofocus,
      readonly: readonly,
      placeholder: placeholder,
      buttons: buttons,
      style: {
        'font-size': '14px',
        ...styles
      },
      sourceEditorNativeOptions: {
        wrap: true,
        highlightActiveLine: true,
        fontSize: '16px',
        tabSize: 1
      }
    };
  }, [minHeight, maxHeight, autofocus, readonly, placeholder, buttons, styles]);
  return /*#__PURE__*/React.createElement(StyledBox, _extends({
    className: className
  }, containerProps), /*#__PURE__*/React.createElement(JoditEditor, {
    id: "rich-editor",
    ref: editor,
    value: value,
    config: configs,
    onBlur: onBlur,
    onChange: handleChange
  }));
};
RichTextEditor.defaultProps = {
  containerProps: {},
  onChange: () => {},
  onBlur: () => {},
  initialValue: '',
  minHeight: 400,
  maxHeight: 800,
  autofocus: false,
  readonly: false,
  placeholder: 'Write Something Here...',
  buttons: 'bold,italic,underline,strikethrough,eraser,|,indent,outdent,left,right,center,justify,|,ul,ol,font,fontsize,paragraph,classSpan,lineHeight,superscript,subscript,|,image,video,|,spellcheck,copyformat,cut,copy,paste,selectall,brush,|,hr,table,link,symbol,|,undo,redo,|,find,source,fullsize,preview,print',
  styles: {},
  setJoditInstance: () => {}
};
RichTextEditor.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  containerProps: PropTypes.object,
  initialValue: PropTypes.string,
  minHeight: PropTypes.number,
  maxHeight: PropTypes.number,
  autofocus: PropTypes.bool,
  readonly: PropTypes.bool,
  placeholder: PropTypes.string,
  buttons: PropTypes.string,
  styles: PropTypes.object,
  setJoditInstance: PropTypes.func
};
export default RichTextEditor;